module.exports = __webpack_public_path__ + "img/weddings_17_V.54601e77.webp";